import { render } from "./IconGo.vue?vue&type=template&id=46ac33ac&scoped=true"
import script from "./IconGo.vue?vue&type=script&lang=js"
export * from "./IconGo.vue?vue&type=script&lang=js"

import "./IconGo.vue?vue&type=style&index=0&id=46ac33ac&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shcho\\Desktop\\home\\git\\test\\cloudpos.kiosk\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46ac33ac"]])

export default __exports__